import { ReactComponent as LoadingCircleIcon } from "../../assets/icons/custom/loading-circle.svg";

const PrimaryButton = ({
  title,
  className = "",
  onClick,
  isLoading = false,
  isDisabled = false,
}: {
  title: string;
  className?: string;
  onClick: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}) => {
  return (
    <button
      className={`dr-flex dr-justify-center dr-items-center dr-w-200 dr-py-14 dr-bg-doctor-darwin-accent-bright-blue-800 dr-text-doctor-darwin-neutral-0 BodyBody2Regular rounded-8 ${className} ${
        isLoading || isDisabled ? "opacity-50 dr-cursor-not-allowed" : ""
      }`}
      onClick={!isLoading && !isDisabled ? onClick : undefined}
    >
      {/* Headings/H2/Bold */}
      {isLoading ? (
        <LoadingCircleIcon className="h-24 w-24 text-neutral-0" />
      ) : (
        title
      )}
    </button>
  );
};

export default PrimaryButton;
